export default __webpack_public_path__ + "static/media/table.33c41428.jpg";